import { ReactNode } from "react";

export default function OrderNumberBadge({
  orderNumber,
  children,
}: {
  orderNumber: number;
  children: ReactNode;
}) {
  return (
    <div style={{ display: "flex" }}>
      <div
        style={{
          border: "2px solid #d8d6db",
          borderRight: "none",
          backgroundColor: "#f6f4f9",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "1rem",
        }}
      >
        {orderNumber}
      </div>
      {children}
    </div>
  );
}
